export default __webpack_public_path__ + "static/media/tech-support-icon.333ac0ab.svg";